import {Contact} from "./contact";

export class OrgContact extends Contact {
  addrName: string;
  addressId: number;
  orgId?: number;
  orgName?: string;
}